import { useTranslation } from 'react-i18next';

import { Drawer } from 'components/shared/index';

import { BasicReportForm } from './BasicReportForm';
import { REPORT_TYPES } from '../type';

type CollectedReportDrawerProps = {
  containerOpen: boolean;
  handleClose: () => void;
  forcedDefaultReportType?: REPORT_TYPES;
};

const CollectedReportDrawer = ({
  containerOpen,
  handleClose,
  forcedDefaultReportType
}: CollectedReportDrawerProps) => {
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.procedures.reports'
  });

  return (
    <Drawer
      open={containerOpen}
      onClose={handleClose}
      title={t('generateReport')}
      anchor="right"
      PaperProps={{
        sx: {
          width: {
            xs: '100%',
            sm: '70%',
            md: '50%',
            lg: '35%',
            xl: '30%'
          }
        }
      }}
    >
      <BasicReportForm
        handleClose={handleClose}
        forcedDefaultReportType={forcedDefaultReportType}
      />
    </Drawer>
  );
};

export default CollectedReportDrawer;
